import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { call, loadConfig } from "../lib/softphone";

/**
 * Click-to-call that upgrades itself.
 *
 * When telephony is configured the click places a real WebRTC call from the
 * browser. When it is not, it stays exactly what the CRM had before - a tel:
 * link that hands off to whatever the device uses - so nothing regresses for
 * anyone who never turns MMDSmart on.
 */
export default function CallButton({ phone, clientId, className, children, testid, title }) {
  const [live, setLive] = useState(false);

  useEffect(() => {
    let ok = true;
    loadConfig()
      .then((c) => ok && setLive(!!(c.enabled && c.sip?.configured)))
      .catch(() => { /* leave it as a tel: link */ });
    return () => { ok = false; };
  }, []);

  if (!phone) return null;

  const onClick = (e) => {
    e.stopPropagation();
    if (!live) return;                 // let the tel: link do its thing
    e.preventDefault();
    call(phone, clientId).catch(() => { /* CallBar shows the reason */ });
  };

  return (
    <a href={`tel:${phone}`} onClick={onClick} className={className} data-testid={testid}
       title={title || (live ? "Call from the browser" : "Call")}>
      {children || (<><Phone className="w-4 h-4" /> Call</>)}
    </a>
  );
}
